export enum ENofeshStatus
{
    Available = 0,
    Hamtana = 1,
    AzalHaMelay = 2
}